<ng-container *ngIf="!!get">
    <tt-button-goto
        *ngIf="get.show_btn_print === '1'"
        ttText="orderhead_print"
        ttGoto="selectreport"
        [ttGotoParms]="{ webpage_name: 'orderhead', argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_btn_email === '1'"
        ttText="orderhead_email_send"
        ttGoto="emailcreate"
        [ttGotoParms]="{ webpage: 'orderhead', argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-order-head-convert-to-order-button
        *ngIf="get.show_button_convert_to_order === '1' && get.ordertype_id == '1'"
        [get]="get"
        [orderHeadProvider]="orderHeadProvider"
        type="link"
        textAlign="left"
        iconAlign="left"
        icon="far fa-plus"
        (converted)="converted.emit()"
    ></tt-order-head-convert-to-order-button>
    <tt-button-goto
        *ngIf="get.show_vertical_purchasing === '1'"
        ttText="orderhead_vertical_purchasing"
        ttGoto="verticalpurchasing"
        [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_button_ohddispatches === '1'"
        ttText="orderhead_ohdispatches"
        ttGoto="ohdispatches"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_ordershipmentstatus === '1'"
        ttText="orderhead_ordershipmentstatus"
        ttGoto="ordershipmentstatus"
        [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto ttText="orderhead_orderlinestatus" ttGoto="orderlinestatus" [ttGotoParms]="{ order_internal_no: get.order_internal_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_btn_pre_payment === '1'"
        ttText="orderhead_prepayments"
        [ttBadge]="get.nbr_of_prepayments"
        ttGoto="prepayments"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_paymentplans === '1'"
        ttText="orderhead_paymentplans"
        ttGoto="paymentplans"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_button_documents === '1'"
        ttText="orderhead_documents"
        [ttBadge]="get.nbr_of_documents"
        ttGoto="documents"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_button_pictures === '1'"
        ttText="orderhead_pictures"
        [ttBadge]="get.nbr_of_pictures"
        ttGoto="pictures"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_create_purchhead_interbranch == '1'"
        ttText="orderhead_create_purch_interbranch"
        ttGoto="orderheadcreateibpurch"
        [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="+get.purch_internal_no_from > 0"
        ttText="orderhead_goto_purch_interbranch"
        ttGoto="purchhead"
        [ttGotoParms]="{ purch_internal_no: get.purch_internal_no_from }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_consignment_create == '1' && get.show_btn_consignment == '1'"
        ttText="orderhead_create_consignment"
        (ttClick)="createConsignment($event)"
        [ttLoading]="creatingConsignment"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_consignments_goto === '1'"
        ttText="orderhead_goto_consignments"
        ttGoto="consignments"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_orderlinecredits === '1'"
        ttText="orderhead_orderlinecredits"
        ttGoto="orderlinecredits"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_btn_invoices === '1'"
        ttText="orderhead_invoices"
        [ttBadge]="get.nbr_of_invoices"
        ttGoto="invoiceheads"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        [ttText]="get.consignmentassembly_custact_no !== '0' ? 'orderhead_consignmentassembly_goto' : 'orderhead_consignmentassembly_new'"
        [ttGoto]="get.consignmentassembly_webpage_name"
        [ttGotoParms]="get.consignmentassembly_parms"
    ></tt-button-goto>
    <tt-button-goto *ngIf="get.show_postcalc === '1'" ttText="orderhead_postcalc" ttGoto="postcalc" [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"></tt-button-goto>
    <tt-button-goto *ngIf="get.show_svea_prepayment === '1'" ttText="orderhead_svea_prepayment" (ttClick)="createSveaPaymentLink()" [ttLoading]="creatingSveaPaymentLink"></tt-button-goto>
    <tt-button-goto *ngIf="get.show_invoice_make === '1'" ttText="orderhead_make_invoice" ttGoto="orderheadmi" [ttGotoParms]="{ order_internal_no: get.order_internal_no }"></tt-button-goto>
    <tt-button-goto *ngIf="get.show_orderpurch === '1'" ttText="orderhead_orderpurch" ttGoto="orderpurch" [ttGotoParms]="{ order_internal_no: get.order_internal_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_button_forms === '1'"
        ttText="orderhead_forms"
        [ttBadge]="get.nbr_of_checklistdata"
        ttGoto="checklistdatas"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_btn_custact === '1'"
        ttText="orderhead_custacts"
        [ttBadge]="get.nbr_of_custacts"
        ttGoto="custactsearch"
        [ttGotoParms]="{ filterfield: 'order_internal_no', filtervalue: get.order_internal_no, custacttype: 'A' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_button_deviation === '1'"
        ttText="orderhead_deviations"
        [ttBadge]="get.nbr_of_deviations"
        ttGoto="deviations"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_button_orderdialog === '1'"
        ttText="orderhead_orderdialog"
        [ttBadge]="get.nbr_of_orderdialogs"
        ttGoto="orderdialog"
        [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_button_timesheetdiary === '1'"
        ttText="orderhead_timesheetdiary"
        ttGoto="timesheetdiary"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto ttText="orderhead_checkpointheads" ttGoto="checkpointheads" [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"></tt-button-goto>
    <tt-button-goto *ngIf="get.show_button_duplicate_order === '1'" ttText="orderhead_duplicate" ttGoto="orderheadcopy" [ttGotoParms]="{ order_internal_no: get.order_internal_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_stocktransallocation === '1'"
        ttText="orderhead_allocations"
        ttGoto="stocktransallocations"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="get.show_orderhead_capjobs === '1'" ttText="orderhead_capjobs" ttGoto="orderheadcapjob" [ttGotoParms]="{ order_internal_no: get.order_internal_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_createcase === '1'"
        ttText="orderhead_createcase"
        ttGoto="createcase"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="get.show_orderform === '1'" ttText="orderhead_orderform" ttGoto="orderform" [ttGotoParms]="{ order_internal_no: get.order_internal_no }"></tt-button-goto>
    <tt-button-save *ngIf="showDynamicSpecialSave" ttText="save" (ttClick)="dynamicSpecialSaveRequested.emit()" [ttLoading]="dynamicSpecialSaving"></tt-button-save>
    <tt-button
        *ngIf="get.show_puch_order_purchaseorder === '1'"
        ttText="orderhead_puch_order_to_purchaseorder"
        ttIcon="fas fa-sync-alt"
        (ttClick)="pushOrderToPurchOrder()"
        [ttLoading]="pushingOrder"
    ></tt-button>
    <tt-button-goto
        *ngIf="get.show_btn_external_cost === '1'"
        ttText="orderhead_external_cost"
        ttGoto="orderheadexternalcost"
        [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_orderheadchoices === '1'"
        ttText="orderhead_orderheadchoices"
        ttGoto="orderheadchoices"
        [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
    ></tt-button-goto>
    <tt-button *ngIf="get.setting_enable_oh_cancel === '1'" ttText="orderhead_cancel" ttType="danger" ttIcon="fad fa-trash" (ttClick)="cancelOrder()" [ttLoading]="cancelling"></tt-button>
    <tt-button *ngIf="get.setting_enable_oh_delete === '1'" ttText="orderhead_delete" ttType="danger" ttIcon="fad fa-trash" (ttClick)="deleteOrder()" [ttLoading]="deleting"></tt-button>
</ng-container>
